import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PagesComponent} from './pages.component';
import {RouterOutlet} from "@angular/router";
import {ThemeModule} from "../theme/theme.module";
import {PagesRoutingModule} from "./pages-routing.module";
import {RealTimeModule} from "./real-time/real-time.module";
import {StatusMonitoringModule} from "./status-monitoring/status-monitoring.module";
import {MonitoringModule} from './monitoring/monitoring.module';

import {HomeComponent} from "./home/home.component";
import {ChangePasswordModule} from './change-password/change-password.module';
import {MessageService} from "primeng/api";
import {MultiAppsModule} from "./multi-apps/multi-apps.module";

@NgModule({
  declarations: [
    PagesComponent,
    HomeComponent,
  ],
  imports: [
    CommonModule,
    RouterOutlet,
    ThemeModule,
    PagesRoutingModule,
    ThemeModule,
    RealTimeModule,
    StatusMonitoringModule,
    MonitoringModule,
    ChangePasswordModule,
    MultiAppsModule,
  ],
  providers: [
    ThemeModule,
    RealTimeModule,
    MessageService,
    StatusMonitoringModule,
    ChangePasswordModule
  ]
})
export class PagesModule {
}
